/*
  This script assumes your theme's CSS is handling the grid layout
  (e.g., the number of columns and responsive breakpoints).
*/
document.addEventListener('algolia.hooks.initialize', function () {

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (originalTemplate, hit, html, components) {

    // Using your preferred image size
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
    return html`
      <div class="ais-hit ais-product">
        <a
          href="https://bici.cc/products/${hit.handle}"
          style="text-decoration: none; color: inherit; display: flex; flex-direction: column; height: 100%;"
        >
          <div style="position: relative; overflow: visible;">
            
            ${hit.tags.includes("_badge_Buy_2_save_20%")
              ? html`<span class="sale-box" data-aos="fade" data-aos-duration="800" style="z-index: 3000000; position: absolute; --left-spacing: 5px !important; --padding-vertical: 7px !important; text-align: center !important; padding: calc(var(--padding-vertical) * var(--FONT-ADJUST-BODY)) 15px !important; width: auto !important; max-width: calc(100% - (var(--left-spacing) * 2)) !important; white-space: nowrap !important; text-overflow: ellipsis !important; overflow: hidden !important; border-radius: var(--btn-radius) !important; top: 0; left: 0; font-size: 11px !important;">Buy 2+ save 20%</span>`
              : html` 
                ${hit.compare_at_price > hit.price
                  ? html`<span class="sale-box" data-aos="fade" data-aos-duration="800" style="z-index: 3000000; position: absolute; --left-spacing: 5px !important; --padding-vertical: 7px !important; text-align: center !important; padding: calc(var(--padding-vertical) * var(--FONT-ADJUST-BODY)) 15px !important; width: auto !important; max-width: calc(100% - (var(--left-spacing) * 2)) !important; white-space: nowrap !important; text-overflow: ellipsis !important; overflow: hidden !important; border-radius: var(--btn-radius) !important; top: 0; left: 0; font-size: 11px !important;">Sale</span>`
                  : ''
                }
              `
            }
  
            <img
              class="ais-hit--picture"
              src="${hitImage.src}"
              srcset="${hitImage.srcset}"
              sizes="${hitImage.sizes}"
              alt="${hit.title}"
              loading="lazy"
            />
          </div>
          
          <div
            class="ais-hit--details"
            style="flex-grow: 1; display: flex; flex-direction: column; justify-content: flex-end; padding-top: 10px;"
          >
            <p class="ais-hit--title">
              ${components.Highlight({ attribute: 'title', hit })}
            </p>

            <p class="ais-hit--price">
              ${
                hit.compare_at_price > hit.price
                  ? html`<b style="color:rgb(237,97,97);">$${hit.price.toFixed(2)}</b> <s style="opacity: 0.7;">$${hit.compare_at_price.toFixed(2)}</s>`
                  : html`<b>$${hit.price.toFixed(2)}</b>`
              }
            </p>
          </div>
        </a>
      </div>
    `;
  });
  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(originalOptions) {

    console.log('beforeInstantSearchOptions hook triggered. Original options:', originalOptions);

    // Create a copy of the original options to modify
    const modifiedOptions = { ...originalOptions };

    // --- Example Modifications ---

    // You can now modify any of the properties listed in your provided `originalOptions`
    // For instance, to change the hitsPerPage:
    // modifiedOptions.hitsPerPage = 25;

    // Or to change a color:
    // modifiedOptions.colors.main = '#FF0000'; // Red main color

    // To set an initial refinement for the hierarchical menu:
    modifiedOptions.initialUiState = {

    };

    // Example of adding or modifying routing configuration via the hook
    // In a real application, you'd define your routing rules here.
    // modifiedOptions.routing = {
    //     router: instantsearch.routers.history({ writeDelay: 400 }),
    //     stateMapping: instantsearch.stateMappings.default,
    // };

    console.log('Modified InstantSearch options:', modifiedOptions);
    return modifiedOptions;
  });
                                           
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {

    console.log(data);
    return _defaultTemplate;
    
  });
});


